export default {
  recoveriesLoading: (state) => state.recoveriesLoading,
  advanceRecoveries: (state) => state.advanceRecoveries
}
